import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ReactNode } from "react";
import moment from "moment";

import { PickersActionBarProps } from "@mui/x-date-pickers";
import { useLocaleText } from "@mui/x-date-pickers/internals";
import Label from "../Label";
import ErrorMessage from "../ErrorMessage";
import Button from "../../buttons/Button";
import getCustomStylesForDatePicker from "./style";

type DatePickerProps = {
  error?: any;
  label?: ReactNode;
  id: string;
  startDateTime: number | null | moment.Moment | Date;
  isDatePickerModalOpen: boolean;
  setIsDatePickerModalOpen: (s: boolean) => void;
  handleSetDateTimeForMomemto: (value: any) => void;
  isDisabled?: boolean;
  disableFuture?: boolean;
};

function CustomActionBar(props: PickersActionBarProps) {
  const { onAccept, onClear, onCancel, onSetToday, actions, className } = props;
  const localeText = useLocaleText();

  const menuItems = actions?.map((actionType: string) => {
    switch (actionType) {
      case "clear":
        return (
          <Button
            text={localeText.clearButtonLabel}
            onClick={() => {
              onClear();
            }}
            key={actionType}
          />
        );
      case "cancel":
        return (
          <Button
            variant="rustPinkSolid"
            onClick={() => {
              onCancel();
            }}
            key={actionType}
            text={localeText.cancelButtonLabel}
          />
        );
      case "accept":
        return (
          <Button
            variant="whiteSolid"
            onClick={() => {
              onAccept();
            }}
            key={actionType}
            text="Select"
          />
        );
      case "today":
        return (
          <Button
            onClick={() => {
              onSetToday();
            }}
            key={actionType}
            text="Now"
          />
        );
      default:
        return null;
    }
  });

  return <div className={`${className} flex justify-end gap-2 p-2`}>{menuItems}</div>;
}

function DateOnlyPickerInput({
  label,
  error,
  startDateTime,
  isDatePickerModalOpen,
  setIsDatePickerModalOpen,
  handleSetDateTimeForMomemto,
  isDisabled,
  id,
  disableFuture,
}: DatePickerProps) {
  return (
    <div>
      <Label label={label} htmlFor={id} labelClasses="text-xxs 2xl:text-xs" />

      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          sx={getCustomStylesForDatePicker()}
          slots={{ actionBar: CustomActionBar }}
          slotProps={{ actionBar: { actions: ["today", "accept"] } }}
          open={isDatePickerModalOpen}
          onOpen={() => setIsDatePickerModalOpen(true)}
          onClose={() => setIsDatePickerModalOpen(false)}
          value={moment(startDateTime) as any}
          disabled={isDisabled}
          onChange={handleSetDateTimeForMomemto}
          selectedSections={undefined}
          onSelectedSectionsChange={undefined}
          disableFuture={disableFuture}
        />
      </LocalizationProvider>
      <ErrorMessage errorMessage={error} />
    </div>
  );
}

export default DateOnlyPickerInput;
